import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { currentCompanyId } from 'src/components/property/UtilityPortalCredentials/currentCompanyId';
import { useStore } from 'src/stores';
import { getPropertyDetailsPath } from './appfolioPushConstants';

/**
 * A link to a property's Details tab on the dashboard, where its Accounts Payable GL accounts are set
 * (LB-5981), opened in a new tab so the bill stays where it is. It needs the property's own portfolio, so
 * it reads that first, and shows nothing until it has it or when it cannot.
 */
export const PropertyDetailsLink = observer(_ref => {
  let children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? undefined : _ref$className,
    propertyLivableId = _ref.propertyLivableId;
  const _useStore = useStore(),
    appfolioGlAccounts = _useStore.appfolioGlAccounts;
  const companyId = currentCompanyId();

  // Without a company there is no link to build, so nothing to read for one.
  useEffect(() => {
    if (companyId && propertyLivableId) appfolioGlAccounts.readPropertyPortfolio(propertyLivableId);
  }, [appfolioGlAccounts, companyId, propertyLivableId]);
  const href = getPropertyDetailsPath(propertyLivableId, appfolioGlAccounts.getPropertyPortfolioId(propertyLivableId), companyId);
  if (!href) return null;
  return /*#__PURE__*/React.createElement("a", {
    className: className,
    href: href,
    rel: "noopener noreferrer",
    target: "_blank"
  }, children);
});